<template>
    <div v-if="isShowMessage" class="message1" :class="[bac===0?'succ':'warn']">
        <div>{{ text }}</div>
    </div>
</template>

<script setup>
import { computed,onMounted,onUnmounted,ref, watch } from 'vue';
import { useStore } from 'vuex';
const store = useStore()
const text = computed(()=>{return store.state.app.message_text})
const bac = computed(()=>{return store.state.app.message_bac})
const isShowMessage = computed(()=> store.state.app.isShowMessage)


</script>

<style lang="scss" scoped>
.message1{
    position: absolute;
    top: 5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 20rem;
    height: 3rem;
    // background: rgb(178, 178, 178);
    z-index: 11;
    border-radius: 5px;
    animation: messageShow 2s forwards;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--message1-color);
    &.succ{
        background: var(--message1-succ-bac);
    }
    &.warn{
        background: var(--message1-warn-bac);
    }
}
</style>